import { gql } from '@apollo/client';
import { client } from 'graphql/client';

export const UPDATE_IS_READ_STATUS = gql`
    query UpdateIsReadStatus($driverId: Long!, $trackingNumber: String!) {
        updateIsReadStatus(driverId: $driverId, trackingNumber: $trackingNumber)
    }
`;

export interface UpdateIsReadStatusVariables {
    driverId: number;
    trackingNumber: string;
}

export interface UpdateIsReadStatusResponse {
    updateIsReadStatus: boolean;
}

export const updateIsReadStatus = async (driverId: number, trackingNumber: string): Promise<boolean> => {
    try {
        const result = await client.query<UpdateIsReadStatusResponse, UpdateIsReadStatusVariables>({
            query: UPDATE_IS_READ_STATUS,
            variables: { driverId, trackingNumber }
        });
        return result.data?.updateIsReadStatus || false;
    } catch (error) {
        console.error('Failed to update read status:', error);
        return false;
    }
};